import { render, staticRenderFns } from "./BankList.vue?vue&type=template&id=3d9490e2&"
import script from "./BankList.vue?vue&type=script&lang=ts&"
export * from "./BankList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports